import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { SignaturesService } from '../../signatures/services/signatures.service'
import { setSignatureSecTwoPatientUnableToSignOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getSignatureSecTwoPatientUnableToSignOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const signaturesService = new SignaturesService(serviceId)
  try {
    const response = yield call([signaturesService, signaturesService.getSignatureSectionTwoPatientUnableToSign])
    const { entity } = response
    yield put(setSignatureSecTwoPatientUnableToSignOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSignatureSecTwoPatientUnableToSignOptions() error: ${e}`))
  }
}
export function* getSignatureSecTwoPatientUnableToSignOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSignatureSecTwoPatientUnableToSignOptions)
}
